module.exports = __webpack_public_path__ + "img/1547756675.e703ad32.jpg";